module.exports = __webpack_public_path__ + "static/william-osler-health-systems-09156d10d8c28a83c2ea6810729221c2.jpg";